// extracted by mini-css-extract-plugin
export var accent = "_60-4";
export var add = "_60-j";
export var addIcon = "_60-k";
export var deleteIcon = "_60-i";
export var disabled = "_60-9";
export var ellipsis = "_60-f";
export var error = "_60-3";
export var form = "_60-5";
export var hideFocus = "_60-2";
export var icon = "_60-7";
export var input = "_60-e";
export var listItem = "_60-h";
export var mediumHeight = "_60-b";
export var noBorder = "_60-8";
export var noRadius = "_60-1";
export var shortHeight = "_60-a";
export var tallHeight = "_60-c";
export var textInput = "_60-0";
export var vertical = "_60-g";
export var veryTallHeight = "_60-d";
export var widget = "_60-6";